import { render, staticRenderFns } from "./lang-switch.vue?vue&type=template&id=15644a24&"
import script from "./lang-switch.vue?vue&type=script&lang=js&"
export * from "./lang-switch.vue?vue&type=script&lang=js&"
import style0 from "./lang-switch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports